// Globalny strażnik tras: bez tokenu wpuszczamy tylko na /login, /register i /reset-password,
// zalogowanego z tych stron odsyłamy do planera.
const PUBLIC_ROUTES = ['/login', '/register', '/reset-password']
// Strony otwarte dla wszystkich, zalogowanych i nie (stary adres polityki prywatności z ekranu zgody Google — przekierowuje na rountine.com).
const OPEN_ROUTES = ['/polityka-prywatnosci']

export default defineNuxtRouteMiddleware((to) => {
    if (OPEN_ROUTES.includes(to.path)) return

    const { isAuthenticated } = useAuth()
    const isPublic = PUBLIC_ROUTES.includes(to.path)

    if (!isAuthenticated.value && !isPublic) {
        // po zalogowaniu wracamy tam, dokąd szedł (np. link „Usuń konto” z rountine.com/usun-konto)
        return navigateTo(to.fullPath === '/' ? '/login' : { path: '/login', query: { next: to.fullPath } })
    }
    if (isAuthenticated.value && isPublic) {
        return navigateTo('/')
    }
})
